import { isVirtualDevice } from '../virtual_components_helpers';
import { load_image_from } from 'src/helpers/interface_helpers';

import type { Device } from 'src/types/Device';
interface DrawerTabItem {
	image?: string | null;
	icon?: string;
}

const loadDeviceImage = (device: Device) => {
	if (isVirtualDevice(device?.type) && device?.image) {
		return load_image_from(device?.image, device?.localImage ? '' : device?.server);
	}
	return null;
};

export const buildDrawerTabItems = (device: Device): DrawerTabItem[] => {
	const image = loadDeviceImage(device);
	return [
		{
			image,
			icon: image === null ? device?.icon || 'far fa-cube' : undefined,
		},
		{ icon: 'fal fa-bell' },
		{ icon: 'fal fa-chart-line' },
		{ icon: 'fal fa-notebook' },
		{ icon: 'fal fa-calendar' },
		{ icon: 'fal fa-link' },
		{ icon: 'fal fa-gears' },
		{ icon: 'fal fa-share-nodes' },
		{ icon: 'fal fa-cog' },
	];
};
